import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TextField,
  Typography,
  Stack,
  TableHead,
  InputAdornment,
  IconButton
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import axios from 'axios';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import Scrollbar from '../components/Scrollbar';
import { API_URL } from '../constant';
import { LoginContext } from '../context/logincontext';

const TABLE_HEAD = [
  { id: 'loan_id', label: 'Loan Id' },
  { id: 'name', label: 'Customer' },
  { id: 'mobile', label: 'Mobile' },
  { id: 'lead_type', label: 'Lead Type' },
  { id: 'state', label: 'State' },
  { id: 'created_at', label: 'Created At' },
  { id: 'cibil_verified', label: 'Cibil Verified' },
  { id: 'aadhaar_verified', label: 'Kyc Verified' }
];

export default function LeadList() {
  const context = useContext(LoginContext);
  const [page, setPage] = useState(0);
  const [value, setValue] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [filteredValue, setFilteredValue] = useState([]);

  useEffect(() => {
    getLosDealerLead();
  }, []);

  async function getLosDealerLead() {
    const dealerId = context?.user.company.dealer_id;
    const res = await axios.get(`${API_URL}/losdata/leads/${dealerId}`);
    if (res.data.status === 'success') {
      setValue(res?.data?.data);
      setFilteredValue(res.data.data);
      enqueueSnackbar('Data fetched successfully', { variant: 'success' });
    } else {
      enqueueSnackbar('Something went wrong', { variant: 'error' });
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilter = (e) => {
    const query = e.target.value.toLowerCase();
    const filteredData = value.filter((v) =>
      Object.values(v).some((val) =>
        String(val).toLowerCase().includes(query)
      )
    );
    setFilteredValue(filteredData);
  };
  
  const redirect = (id) => {
    navigate(`/dashboard/lead/${id}/status`);
  };

  return (
    <Card sx={{ width: 'auto', p: 3, boxShadow: 3, borderRadius: 2 }}>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={3}
      sx={{ borderBottom: 1, borderColor: 'divider', pb: 2 }}
    >
      <Typography variant="h4" sx={{ fontFamily:'sans-serif',  borderBottom: 1, borderColor: 'secondary.main'}}>
        Customer List
      </Typography>
      <TextField
        type="search"
        variant="outlined"
        onChange={handleFilter}
        placeholder="Search/ Loan Id/ Customer/ Mobile/ Lead Type/ State..."
        sx={{ width: 500, backgroundColor: 'white', borderRadius: 1 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Stack>
    <Scrollbar>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5', borderBottom: 2, borderBottomColor:'black' }}>
              {TABLE_HEAD.map((head) => (
                <TableCell key={head.id} align="center" sx={{ fontWeight: 500, fontSize:20, fontFamily:'fantasy'}}>
                  {head.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredValue?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((v, index) => (
              <TableRow
                key={index}
                hover
                sx={{
                  cursor: 'pointer',
                  backgroundColor: index % 2 ? '#fafafa' : 'white',
                  '&:hover': { backgroundColor: '#f0f0f0' },
                }}
                onClick={()=>redirect(v.loan_id)}
              >
                <TableCell align="center">{v?.loan_id}</TableCell>
                <TableCell align="center">{v?.name}</TableCell>
                <TableCell align="center">{v?.mobile}</TableCell>
                <TableCell align="center">{v?.lead_type}</TableCell>
                <TableCell align="center">{v?.state}</TableCell>
                <TableCell align="center">{moment(v?.created_at).format('DD-MM-YYYY')}</TableCell>
                <TableCell align="center">
                  {v?.cibil_verified ? (
                    <CheckCircleIcon color="success" />
                  ) : v?.state === 'cibil_requested' || v?.state === 're_cibil_requested' ? (
                    <ReportProblemIcon color="warning" />
                  ) : (
                    <CancelIcon color="error" />
                  )}
                </TableCell>
                <TableCell align="center">
                  {v?.aadhaar_verified ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 20, 30]}
        component="div"
        count={filteredValue.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Scrollbar>
  </Card>

  );
}